const iconRetirement = `
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h20v20H0z"/>
      <path
        class="icon-color"
        fill="#7A8E96"
        fill-rule="nonzero"
        d="M17.865 6.662 16.764 5.56c-1.23-1.23-2.707-1.289-3.446-1.218l1.536-1.535a.49.49 0 0 0 .105-.515.472.472 0 0 0-.434-.293h-2.261c-.973 0-1.793.504-2.262 1.195A2.733 2.733 0 0 0 7.74 2H5.478a.472.472 0 0 0-.328.808l1.535 1.535A4.212 4.212 0 0 0 3.24 5.56l-1.102 1.1a.49.49 0 0 0-.105.516c.07.176.246.293.433.293h3.211a2.695 2.695 0 0 0-.668 1.792v2.26c0 .188.118.364.293.434a.46.46 0 0 0 .516-.105l3.528-3.526-1.254 8.738H6.486a.47.47 0 0 0-.469.468c0 .258.211.469.469.469h7.02a.47.47 0 0 0 .469-.469.47.47 0 0 0-.47-.468H11.9l-1.254-8.738 3.528 3.526a.5.5 0 0 0 .516.105.471.471 0 0 0 .292-.433v-2.26c0-.669-.234-1.29-.668-1.793h3.212a.472.472 0 0 0 .433-.293.468.468 0 0 0-.094-.515z"
      />
    </g>
  </svg>
`

export default iconRetirement
